import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { CustomerContact } from 'gung-standard';
import { JeevesCustomerContactListConfigService } from 'gung-standard-jeeves';
import { SjoborgJeevesCustomerContactCardListComponent } from '../components/sjoborg-jeeves-customer-contact-card-list/sjoborg-jeeves-customer-contact-card-list.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgJeevesCustomerContactListConfigService extends JeevesCustomerContactListConfigService {
  getLayouts(): ListLayout<CustomerContact>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SjoborgJeevesCustomerContactCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'CustomerContacts grid'
      }
    ];
  }
}
